export default "__VITE_ASSET__C47fnNRY__"